import { AimOutlined, ControlOutlined, TabletOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { DEVICE_ICONS } from './DeviceIcon.constants';
import styles from './DeviceIcon.module.css';

export const DeviceIcon = ({ type, actualSegment, connectionStatus, disconnectTime, formatTime }) => {
  const getDeviceIconClass = () => {
    switch (actualSegment) {
      case DEVICE_ICONS.DELETED:
        return styles.deviceIconDeleted;
      case DEVICE_ICONS.BLOCK:
        return styles.deviceIconBlocked;
      case DEVICE_ICONS.ACTUAL:
      case DEVICE_ICONS.ONLINE:
        return connectionStatus ? styles.deviceIconActualConnected : styles.deviceIconActualDisconnected;
      default:
        return '';
    }
  };

  const iconProps = {
    className: `${styles.deviceIcon} ${getDeviceIconClass()}`,
  };

  const iconComponents = {
    tablet: TabletOutlined,
    panel: AimOutlined,
    router: ControlOutlined,
  };

  const IconComponent = iconComponents[type];

  const tooltipMessage = connectionStatus ? 'В сети' : disconnectTime ? formatTime(disconnectTime) : 'неизвестно';

  if (!IconComponent) {
    console.warn(`Unknown device type: ${type}`);
    return null;
  }

  return (
    <Tooltip title={tooltipMessage}>
      <IconComponent {...iconProps} />
    </Tooltip>
  );
};
